// @ts-nocheck
import { snakeCase } from 'snake-case';

import { Fields } from '$lib/constants/fields';
import { slugify } from './common';

export function cleanUpHtml(html) {
  return (html || '').replace(/&lt;/gi, '<').replace(/&gt;/gi, '>');
}

export function sanitizeHtml(html) {
  const map = {
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  };

  return (html || '').replace(/[<>"']/g, function (m) {
    return map[m];
  });
}

export function getFilteredFields(fields = '') {
  const splittedFields = fields.trim().replaceAll('\r', '').split('\n');
  return splittedFields.filter((splittedField) => !!splittedField);
}

export function transformFieldsToHtml(fields) {
  let fieldsInHtml = '';

  fields.forEach((field) => {
    if (!field) {
      return;
    }

    const { name, placeholder, fieldType, options } = field;

    const transformedName = snakeCase(slugify(name));

    fieldsInHtml = fieldsInHtml.concat(`<label for="${transformedName}">${name}</label>\n`);

    switch (fieldType) {
      case Fields.DROPDOWN:
        {
          const displayOption = options?.reduce((acc, curr) => {
            acc = acc.concat(
              `<option value="${sanitizeHtml(curr)}">${sanitizeHtml(curr)}</option>\n`
            );

            return acc;
          }, '');

          fieldsInHtml = fieldsInHtml.concat(`
            <select name="${sanitizeHtml(transformedName)}" placeholder="${sanitizeHtml(
            placeholder
          )}" required="true">\n${displayOption}</select>\n
          `);
        }
        break;
      case Fields.INPUT_NUMBER:
        fieldsInHtml = fieldsInHtml.concat(
          `<input type="number" name="${sanitizeHtml(transformedName)}" placeholder="${sanitizeHtml(
            placeholder
          )}" required="true" />\n`
        );
        break;
      case Fields.TEXTAREA:
        fieldsInHtml = fieldsInHtml.concat(
          `<textarea name="${sanitizeHtml(transformedName)}" placeholder="${sanitizeHtml(
            placeholder
          )}" required="true"></textarea>\n`
        );
        break;
      case Fields.INPUT:
      default:
        fieldsInHtml = fieldsInHtml.concat(
          `<input name="${sanitizeHtml(transformedName)}" placeholder="${sanitizeHtml(
            placeholder
          )}" required="true" />\n`
        );
        break;
    }
  });

  return fieldsInHtml;
}

export function highlightText(text, keyword) {
  let regex = new RegExp(`(${keyword})`, 'gi');

  return text.replace(regex, '<mark>$1</mark>');
}

export function correctULTagFromQuill(htmlStr) {
  // Parse the HTML string into a document object
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlStr, 'text/html');

  // Find all <li> elements with 'data-list="bullet"'
  const bulletItems = doc.querySelectorAll('li[data-list="bullet"]');

  bulletItems.forEach((item) => {
    // Remove 'data-list' attribute
    item.removeAttribute('data-list');

    // Wrap the item in a <ul> tag
    const ul = document.createElement('ul');

    ul.classList.add('list-disc');

    item.parentNode.insertBefore(ul, item);

    ul.appendChild(item);
  });

  return doc.body.innerHTML;
}

export function removePoweredBy(htmlString) {
  // Create a temporary element
  const tempDiv = document.createElement('div');

  tempDiv.innerHTML = htmlString;

  // Find and remove the specific element
  const elementsToRemove = tempDiv.querySelectorAll('p[data-f-id="pbf"]');

  elementsToRemove.forEach((element) => element.remove());

  // Return the updated HTML string
  return tempDiv.innerHTML;
}
